<fieldset *ngIf="configurationClass" [formGroup]="maintenanceSummary">
  <legend>
    Maintenance Summary
    <fl-maintenance-image-control
      *ngIf="flightLogId"
      [flightLogId]="flightLogId"
    ></fl-maintenance-image-control>
  </legend>
  <div data-row-span="12">
    <div data-field-span="3">
      <label>Starting Hobbs</label>
      <input
        type="number"
        [readonly]="features.startingHobbsReadonly"
        formControlName="startingHobbsReading"
        min="0"
      />
    </div>
    <div data-field-span="3">
      <label>Ending Hobbs</label>
      <input type="number" formControlName="endingHobbsReading" min="0" />
    </div>
    <div data-field-span="2" class="readonly">
      <label>Flight Time</label>
      <input type="number" readonly formControlName="totalFlightTime" min="0" />
    </div>
    <div data-field-span="2" [ngClass]="{ readonly: !isTraining }">
      <label>Total Landings</label>
      <input *ngIf="!isTraining" type="number" readonly formControlName="totalLandings" min="0" />
      <input *ngIf="isTraining" type="number" formControlName="totalLandings" min="0" />
    </div>
    <div data-field-span="2" [ngClass]="{ readonly: !isTraining }">
      <label>Run On Landings</label>
      <input *ngIf="!isTraining" type="number" readonly formControlName="runOnLandings" min="0" />
      <input *ngIf="isTraining" type="number" formControlName="runOnLandings" min="0" />
    </div>
  </div>
  <fl-engine-maintenance-simple
    *ngIf="showEngineOne"
    [maintenanceParameters]="configurationClass?.maintenanceParameters"
    [engine]="maintenanceSummary.get('engine1')"
    [engineNumber]="1"
  ></fl-engine-maintenance-simple>
  <fl-engine-maintenance-simple
    *ngIf="showEngineTwo"
    [maintenanceParameters]="configurationClass?.maintenanceParameters"
    [engine]="maintenanceSummary.get('engine2')"
    [engineNumber]="2"
  ></fl-engine-maintenance-simple>
  <fl-maintenance-part133
    *ngIf="isFlightTypePart133"
    [maintenanceSummary]="maintenanceSummary"
  ></fl-maintenance-part133>
</fieldset>
<fl-message-box [messages]="validationErrors$ | async" [level]="'error'"></fl-message-box>
